import ninegrid from "../index.js";
import { ngElement } from './_ngElements.js';

class ngColExpand extends ngElement
{
	#owner;
	#cell;
	#orgColor;
	#prevWidth;
	
	constructor () {
		super();
		this.applyBaseStyle();
	}
	
	connectedCallback() {

		this.shadowRoot.innerHTML = ``;

		super.connectedCallback();
		
		this.#owner		= this.getRootNode().host;
		this.#cell		= this.closest("th,td");

		ninegrid.j.querySelectorAll(this).addClass("expand");
		
		$(this).off("click", this.#onClick);
		$(this).on("click", this.#onClick);
	};

	
	#onClick = e => {
		e.preventDefault();
		e.stopPropagation();
		
		if (ninegrid.j.querySelectorAll(this).hasClass("expand")) {
			this.#collapse();
		}
		else {
			this.expand();
		}
	};
	
	expand = () => {
		if (ninegrid.j.querySelectorAll(this).hasClass("expand")) return;
		
		$(this).addClass("expand");
		this.#cell.style.color = this.#orgColor;
		
		const colIndex	= parseInt(this.#cell.dataset.col);
		const colSpan	= this.#cell.colSpan || 1;
		for (var i = 0; i < colSpan; i++) {
			this.#owner.columns.width(colIndex+i, this.#prevWidth[i]);
		}
	};
	
	#collapse = () => {
		if (!ninegrid.j.querySelectorAll(this).hasClass("expand")) return;
		
		$(this).removeClass("expand");
		this.#orgColor = this.#cell.style.color;
		this.#cell.style.color = "transparent";
		this.#prevWidth = [];
		
		const colIndex	= parseInt(this.#cell.dataset.col);
		const colSpan	= this.#cell.colSpan || 1;
		const w			= 20 / colSpan;
		for (var i = 0; i < colSpan; i++) {
 			const col = this.#owner.body.querySelector(`colgroup col[data-col="${colIndex+i}"]`);
			this.#prevWidth.push(col.getAttribute("width"));
			this.#owner.columns.width(colIndex+i, w);
		}
	};
}

if (!customElements.get('ng-col-expand')) {
	customElements.define("ng-col-expand", ngColExpand);
}

